<template>
  <div class="page-cards flex column">
    <resize-observer @notify="__resizeHanlder" />
    <el-row>
      <el-col :span="24">
        <masonry v-if="loading" :cols="masonryCols" :gutter="10">
          <customer-card
            v-for="(item, index) in [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]"
            :key="index"
            @card-click-action="$emit('card-click-action', $event)"
            :actions="actions"
            :data="item"
            :loading="true"
            :filterables="true"
          />
        </masonry>

        <!-- { default: 4, 1200: 1, 1000: 1, 480: 1 } -->
        <masonry v-else :cols="masonryCols" :gutter="10">
          <customer-card
            v-for="(item, index) in items"
            :key="index"
            :actions="actions"
            :data="item"
            :loading="loading"
            :keys-data="keysCard"
            @card-click-action="$emit('card-click-action', $event)"
          />
        </masonry>

        <el-card v-if="items.length === 0 && loading === false">
          <div class="text-center">
            <h1>No tienes prospectos</h1>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row>
      <el-col :sm="24">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="paginationApi.currentPage"
          :page-sizes="paginationApi.pageSizes"
          :page-size="paginationApi.pageSize"
          :layout="paginationLayout"
          :total="paginationApi.total"
          hide-on-single-page
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import throttle from "lodash/throttle";

export default {
  name: "ProspectCards",
  components: {
    "customer-card": () => import("@/components/PersonCard.vue")
  },
  props: {
    actions: {
      type: Array
    },
    search: {
      type: String,
      default: null,
      required: false
    },
    seller_filter: {
      type: [Number, String],
      default: null,
      required: false
    },
    filterList: {
      type: Array,
      default: null,
      required: false
    },
    module: {
      type: String,
      required: false,
      default: null
    },
    items: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    paginationApi: {
      type: Object,
      required: false,
      default: () => ({
        currentPage: 1,
        pageSize: 10,
        total: 0,
        pageSizes: [10, 20, 30, 50, 100]
      })
    }
    // ,
    // currentPage: {
    //   type: Number,
    //   default: 1
    // },
    // pageSize: {
    //   type: Number,
    //   default: 10
    // },
    // totalItems: {
    //   type: Number,
    //   default: 0
    // }
  },
  data() {
    return {
      data: {},
      paginationLayout: "total, sizes, prev, pager, next, jumper",
      title: "",
      description: "",
      list: [],
      masonryCols: 4,
      formOpen: false,
      isMounted: false,
      keysCard: {
        name: "CompanyName",
        type: "JobTitle",
        address: "ContactAddress",
        code: "ContactCode",
        code2: "CustomerCode"
      }
    };
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    __resizeHanlder: throttle(function (e) {
      if (window.innerWidth <= 480) {
        this.masonryCols = 1;
        this.paginationLayout = "sizes, prev, pager, next";
      } else if (window.innerWidth <= 600) {
        this.masonryCols = 1;
        this.paginationLayout = "total, sizes, prev, pager, next";
      } else if (window.innerWidth <= 700) {
        this.masonryCols = 2;
        this.paginationLayout = "total, sizes, prev, pager, next";
      } else if (window.innerWidth <= 800) {
        this.masonryCols = 2;
        this.paginationLayout = "total, sizes, prev, pager, next, jumper";
      } else if (window.innerWidth <= 1000) {
        this.masonryCols = 2;
        this.paginationLayout = "total, prev, pager, next, jumper";
      } else if (window.innerWidth <= 1200) {
        this.masonryCols = 2;
        // this.paginationLayout = "sizes, prev, pager, next";
      } else {
        this.paginationLayout = "total, sizes, prev, pager, next, jumper";
        this.masonryCols = 3;
      }
    }, 700),
    onClickOutside() {
      this.formOpen = false;
    },
    openForm() {
      this.formOpen = true;
    },
    closeForm() {
      setTimeout(this.onClickOutside, 100);
    },
    handleSizeChange(val) {
      this.$emit("update-page-size", val);
    },
    handleCurrentChange(val) {
      this.$emit("update-current-page", val);
    }
  },
  created() {
    this.__resizeHanlder();
  },
  mounted() {
    this.isMounted = true;
  }
};
</script>

<style lang="scss">
.page-sales {
  .page-header {
    margin-bottom: 20px;
  }

  .list {
    padding: 10px 20px;
    margin: 0 -20px;
    margin-top: 20px;

    .masonry {
      column-count: 4;
      column-gap: 40px;
    }
  }
}

/* Masonry on large screens */
@media (max-width: 1200px) {
  .page-sales {
    .list {
      .masonry {
        column-count: 3;
      }
    }
  }
}

/* Masonry on medium-sized screens */
@media (max-width: 1000px) {
  .page-sales {
    .list {
      .masonry {
        column-count: 2;
      }
    }
  }
}

/* Masonry on small screens */
@media (max-width: 480px) {
  .page-sales {
    .list {
      .masonry {
        column-count: 1;
      }
    }
  }
}
</style>
